import { render, staticRenderFns } from "./reg-finish.vue?vue&type=template&id=4a5902d3&scoped=true&"
import script from "./reg-finish.vue?vue&type=script&lang=js&"
export * from "./reg-finish.vue?vue&type=script&lang=js&"
import style0 from "./reg-finish.vue?vue&type=style&index=0&id=4a5902d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5902d3",
  null
  
)

export default component.exports